<div
  #tooltip
  class="mdc-tooltip mat-mdc-tooltip"
  [ngClass]="tooltipClass"
  (animationend)="_handleAnimationEnd($event)"
  [class.mdc-tooltip--multiline]="_isMultiline"
>
  {{ message }}
  <span class="zef-color-primary-inverted zef-cursor-pointer" i18n (click)="onShowHelpItem()">Click for more...</span>
</div>
